import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { motion } from "framer-motion";
import Typography from "core/components/Typography";
import { CredentialNavSection } from "modules/admin/CredentialNavSection";
import useCurrentUser from "core/hooks/useCurrentUser";
import useActiveMembership from "core/hooks/useActiveMembership";
import { getUserStatus } from "./constants";
import { REVERSE_LOOKUP_ROLES, ROLES } from "core/constants";

const UserProfileCredentialsPage = () => {
  const queryClient = useQueryClient();
  const { userId } = useParams();
  const { currentUser } = useCurrentUser();
  const { activeMembership } = useActiveMembership();

  const profileUser = {
    ...activeMembership,
    ...currentUser,
    roleLabel: ROLES[REVERSE_LOOKUP_ROLES[activeMembership.role]],
  };

  return (
    <motion.div style={{ marginBottom: "30vh" }}>
      <Typography variant="h2">Data Credentials</Typography>
      <CredentialNavSection
        type="user"
        entity={profileUser}
        onMutationSuccess={() => {
          queryClient.invalidateQueries({
            queryKey: ["user-profiles", { userId }],
          });
        }}
      />
    </motion.div>
  );
};

export default UserProfileCredentialsPage;
